import { axiosGet } from "../../../axios/axios-config";
export const IsUserLoggedIn = async (user: {
  email: string;
  first_name: string;
  last_name: string;
  token: string;
  id: number;
  customer_id: string | null;
}) => {
  if (
    user.token &&
    user.email &&
    user.first_name &&
    user.last_name &&
    user.id
  ) {
    const response = await axiosGet("/auth/check-login/", {});
    if (response?.success) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
